import React from "react"

const DishTv=()=>{
   return (
     <h1>DishTv</h1>
   )
}

export default DishTv